<script lang="ts">
    import Vue from "vue";
    import { Component } from 'vue-facing-decorator';
    import { KendoGrid } from "@Kendo/Components/KendoGrid";
    import KendoGridColumnsEditorDialog from "@Kendo/Components/KendoGridColumnsEditorDialog.vue";
    import { ProjectsGridViewModel } from "@Quest/Projects/Components/ProjectsGrid";

    @Component({
        props: {
            viewModel: { type: Object, required: true },
        },
        components: {
            KendoGridColumnsEditorDialog
        }
    })
    export default class ProjectsGrid extends Vue
    {
        get vm(): ProjectsGridViewModel { return this.$props.viewModel as ProjectsGridViewModel; }

        get grid(): KendoGrid | null { return this.vm?.grid; }

        get columnsEditorDialogOpened(): bool { return this.vm?.columnsEditorOpened ?? false; }

        columnsEditorOpened: boolean = false;

        closeColumnsEditor()
        {
            this.vm.columnsEditorOpened = false;
        }
    }
</script>

<template>
    <div class="portfolio-grid">
        <KendoGridColumnsEditorDialog :propOpened="columnsEditorDialogOpened"
                                      :propGrid="grid"
                                      @close-dialog="closeColumnsEditor" />

        <div id="pbGrid"></div>
    </div>
</template>

<style>
    /* Ensure dropdown visibility */
    .portfolio-grid .k-grid td {
        overflow: visible !important;
    }

    .k-table-tbody .k-table-row.k-selected > .k-table-td {
        background-color: #ffffff;
    }

    .k-table-tbody .k-table-row.k-alt.k-selected > .k-table-td {
        background-color: #f1f1f1;
    }
</style>

